import './InputGroup.css';

export const InputGroup = ({ children }: { children: string | JSX.Element | JSX.Element[] }) => {
	return <div className="input-group">{children}</div>;
};
